import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MuiLoader from './Loader';

interface MenuItemWithOnClick {
    item: any;
    onClick?: () => void;
    loading?: boolean;
    disabled?: boolean;
    hide?: boolean;
    render?: (item: any) => void;
}

interface MenuProp {
    menuItems: MenuItemWithOnClick[];
    mt?: string | number;
    loading?: boolean;
}

export default function PositionedMenu({ menuItems, mt, loading }: MenuProp) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    //testing
    const handleClose = async () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = async (menuItem: any) => {
        if (menuItem?.onClick) {
            await menuItem.onClick();
        }
        handleClose();
    };

    return (
        <div style={{ marginTop: mt }}>
            <IconButton onClick={handleClick} sx={{ marginRight: 1 }}>
                <MoreVertIcon htmlColor="black" />
            </IconButton>

            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                {menuItems.map((menuItem, index) => {
                    const { hide, render, item, loading, disabled } = menuItem;
                    if (hide) return null;
                    if (loading) {
                        return (
                            <MenuItem sx={{ minWidth: '100px' }}>
                                <MuiLoader loading={!!loading} size="20px" />
                            </MenuItem>
                        );
                    }
                    return (
                        <MenuItem key={index} disabled={disabled} onClick={() => handleMenuItemClick(menuItem)}>
                            {render ? render(menuItem) : item}
                        </MenuItem>
                    );
                })}
            </Menu>
        </div>
    );
}
